import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card, CardBody, Dialog, IconButton, Select, Typography, Option, Button } from '@material-tailwind/react'
import { SwitchUserRoleSchema } from 'app/admin/utils/authValidation'
import { setSwitchedRole } from 'features/authSlice'
import { useAppDispatch, useAppSelector } from 'features/hooks'
import { useRouter } from 'next/navigation'
import { appHomePath } from '@/lib/appHomePath'
import { Formik } from 'formik'
import { useSwitchUserRoleMutation } from 'graphql/generated/graphql'
import React from 'react'
import { toast } from 'react-toastify'

interface SwitchUserRoleProps {
    roles: any
    userId: number
    switchRoleModal: boolean
    setSwitchRoleModal: any,
    handleSwitchOpen: any
}

const SwitchUserRole: React.FC<SwitchUserRoleProps>  = ({ roles, userId, switchRoleModal, setSwitchRoleModal, handleSwitchOpen }) => {


    const dispatch = useAppDispatch()
    const router = useRouter()
    const currentUser = useAppSelector((state: any) => state.culineerAuth.user)

    const [switchRole, {loading: switchLoading}] = useSwitchUserRoleMutation({fetchPolicy: 'no-cache'})

    const getDefaultRole = () => {
        const role = roles?.find((role: any) => {
          return role?.default
        })
  
         return role?.id
    }

    return (
        <Dialog
            //size="lg"
            open={switchRoleModal}
            handler={handleSwitchOpen}
            data-modal-backdrop="static"
            data-dialog-close={false}
            data-dialog-backdrop-close={false}
            className="bg-transparent shadow-none"
        >
            <Card className="mx-auto w-full max-w-[24rem]">
                <CardBody className="flex flex-col gap-4">
                    <div className='flex justify-between'>
                        <div>
                            <Typography variant="h6" color="blue-gray">
                            Switch User Role
                            </Typography>
                        </div>
                        <IconButton
                            color="blue-gray"
                            size="sm"
                            variant="text"
                            onClick={handleSwitchOpen}
                        >
                            <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                            className="h-5 w-5"
                            >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M6 18L18 6M6 6l12 12"
                            />
                            </svg>
                        </IconButton>
                    </div>
                    <Formik
                        initialValues={{ roleId: getDefaultRole() as number }}
                        validationSchema={SwitchUserRoleSchema}
                        onSubmit={async (values, { setSubmitting }) => {
                            try {
                                const response = await switchRole({
                                    variables: {
                                        roleId: values.roleId as number,
                                        userId,
                                    },
                                })
                                if (response !== undefined) {
                                    setSubmitting(false)
                                    setSwitchRoleModal(!switchRoleModal)
                                    toast.success('Role switched successfully')
                                    const switchedRoles = response.data?.switchUserRole.userRoles
                                    dispatch(setSwitchedRole(switchedRoles))
                                    // Take them to the home screen of the role they just switched to, from any page
                                    // (the auth wrapper only redirects from a few routes such as /discover).
                                    const newRole = switchedRoles?.find((role: any) => role?.default)?.role?.name?.toLowerCase()
                                    router.push(newRole === 'admin' ? '/admin' : appHomePath({ ...currentUser, userRoles: switchedRoles, roles: switchedRoles }))
                                    return
                                }
                            } catch (error: any) {
                                setSubmitting(false)
                                return toast.error(error.message)
                            }
                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleSubmit: handleSwitchRoleSubmit,
                            isSubmitting,
                            setFieldValue,
                        }) => (
                            <form onSubmit={handleSwitchRoleSubmit}>
                                <div
                                className={`${
                                    errors.roleId && touched.roleId ? 'mb-4' : 'mb-6'
                                }`}
                                >
                                <Select
                                    label="Roles"
                                    className="flex h-12 items-center justify-center rounded-lg"
                                    name="membershipType"
                                    onChange={(val) => setFieldValue('roleId', val)}
                                    placeholder="Select membership type"
                                    defaultValue={values.roleId?.toString()}
                                    value={values.roleId?.toString()}
                                >
                                    {roles?.map((role: any, index: number) => (
                                        <Option
                                            key={index}
                                            value={String(role?.id)}
                                        >
                                            {role?.role?.name?.toUpperCase()}
                                        </Option>
                                    ))}
                                </Select>
                                </div>
                                <div className="flex w-full place-content-center items-center space-x-8 pt-4">
                                <button onClick={handleSwitchOpen} className="px-4 py-2 bg-transparent text-gray-600 hover:bg-gray-100 rounded-full">Cancel</button>
                                <Button
                                    className="w-40 rounded-full bg-[#85C349] capitalize"
                                    type="submit"
                                    disabled={switchLoading || isSubmitting}
                                >
                                    {switchLoading || isSubmitting ? (
                                    <FontAwesomeIcon
                                        icon={faSpinner}
                                        className={' h-6 w-6 animate-spin text-white'}
                                    />
                                    ) : (
                                    'Switch Role'
                                    )}
                                </Button>
                                </div>
                            </form>
                        )}
                    </Formik>
                </CardBody>
            </Card>
        </Dialog>
    )
}

export default SwitchUserRole